import { FulfillmentType } from '../types/ProductDelivery';

export function fulfillmentOptionToString(fulfillmentOption: FulfillmentType): string {
	if (!isValidFulfillmentOption(fulfillmentOption)) return null;
	if (fulfillmentOption === FulfillmentType.InStorePickup) {
		return 'Drive Thru Pickup';
	} else if (fulfillmentOption === FulfillmentType.LocalDelivery) {
		return 'Local Delivery';
	} else {
		return 'Shipping';
	}
};

export function isValidFulfillmentOption(fulfillmentOption: FulfillmentType): boolean {
	return [
		FulfillmentType.InStorePickup, 
		FulfillmentType.LocalDelivery, 
		FulfillmentType.StandardShipping
	].some(option => option === fulfillmentOption);
};